export let productCenterDriveViewEN = {
  content: {
    h1: "DiL Solution",
    h2: "Restore Real Driving Experience",
    h3: "Close-Loop Experience",
    driveLoopImg: require("@/static/img/DriverClosedLoop_en.webp"),
    h4: "We apply the latest virtual reality technology in the field of visual restoration to the construction of driving simulator, combined with the autonomous driving simulation test and verification development platform system GaiA, to restore the real driving feelings, so that the driver's subjective feeling assessment becomes accurate and convincing.",
    h5: "Provide a Complete Driving Experience",
    h6: "Deliver a complete driving/riding experience to the driver at the prototyping phase of automated driving system development.",
    h7: "Parameter Access",
    h8: "Replacement or adjustment of all algorithms and hardware can be easily achieved through parametric configuration",
    h9: "DiL Solution Based on PDGaiA of PilotD Automotive",
    h10: "Bring you different driving simulation experience",
  },
  driveSolution: {
    title: "DiL Solution Based on PDGaiA of PilotD Automotive",
    content:
      "The Driver-in-the-Loop (DIL) solution integrates PDGaiA with high-performance motion simulators. Coupled with high-fidelity vehicle dynamics models and proprietary motion washout algorithm, it delivers physiologically accurate driving sensations to enhance realism and immersion in simulation.",
  },
  benchmark: {
    parameters: {
      title: "Benchmark Effective Parameters",
      content: {
        effectiveLoadCapacity: "Effective load capacity",
        longitudinalDisplacement: "Longitudinal displacement (±X axis)",
        lateralDisplacement: "Lateral displacement (±Y axis)",
        verticalLift: "Vertical lift (±Z axis)",
        pitch: "Pitch (θ<sub>X</sub>)",
        roll: "Roll (θ<sub>Y</sub>)",
        yaw: "Yaw (θ<sub>Z</sub>)",
        operationalNoiseLevel: "Operational noise level (dB(A))",
      },
    },
    performance: {
      title: "Benchmark Dynamic Performance Metrics",
      content: {
        linearVelocity: "Linear velocity (m/s)",
        linearAcceleration: "Linear acceleration (m/s²)",
        angularVelocity: "Angular velocity (rad/s)",
        angularAcceleration: "Angular acceleration (rad/s²)",
        responseTime: "Response time to target coordinates (ms)",
        key: "",
      },
    },
  },
};
export let productCenterDriveViewCN = {
  content: {
    h1: "DiL 驾驶员在环解决方案",
    h2: "还原真实的驾驶感受",
    h3: "闭环体验",
    driveLoopImg: require("@/static/img/DriverClosedLoop.png"),
    // h4: "我们将视觉还原领域最新的虚拟现实技术运用到了驾驶模拟器的构建中，结合自动驾驶仿真测试验证开发平台系统PDGaiA，还原真实的驾驶感受，使驾驶员主观感受测评变得精准且具有说服力。",
    h5: "提供完整的驾乘感受",
    h6: "在自动驾驶系统开发初期提供驾驶员完整的驾驶或乘坐感受",
    h7: "参数接入",
    h8: "所有算法和硬件的更换和调整都可以简单通过参数化设置实现",
    h9: "基于沛岱汽车PDGaiA的驾驶员在环解决方案",
    h10: "为你带来不一样的驾驶模拟体验",
  },
  driveSolution: {
    title: "驾驶员在环解决方案",
    content:
      "是PDGaiA与高性能运动模拟器的结合，配合动力学模型，通过先进的自研运动洗出算法，真实准确地还原驾驶员在车辆驾驶过程中的感受，提高驾驶员在仿真过程中的驾驶运动体验和沉浸感。",
  },
  benchmark: {
    parameters: {
      title: "台架有效参数",
      content: {
        effectiveLoadCapacity: "有效负荷",
        longitudinalDisplacement: "纵向位移",
        lateralDisplacement: "横向位移",
        verticalLift: "垂直升降",
        pitch: "俯仰",
        roll: "滚转",
        yaw: "扭转",
        operationalNoiseLevel: "运行噪音",
      },
    },
    performance: {
      title: "台架动态性能指标",
      content: {
        linearVelocity: "线速度",
        linearAcceleration: "线加速度",
        angularVelocity: "角速度",
        angularAcceleration: "角加速度",
        responseTime: "台架对目标坐标的响应时间",
        key: "",
      },
    },
  },
};
